/**
 * Please note:
 *
 * Translations are provided as an illustration only and are
 * not guaranteed to be accurate or error-free.
 *
 * They are designed to show developers where to store their
 * chosen phrase or spelling variant in the target language.
 */

export const AG_CHARTS_LOCALE_PL_PL: Record<string, string> = {
    ariaAnnounceChart: 'wykres, ${seriesCount}[number] serii',
    ariaAnnounceFlowProportionLink: 'link ${index} z ${count}, od ${from} do ${to}, ${sizeName} ${size}',
    ariaAnnounceFlowProportionNode: 'węzeł ${index} z ${count}, ${description}',
    ariaAnnounceGaugeChart: 'wykres wskaźnikowy, ${caption}',
    ariaAnnounceHierarchyChart: 'wykres hierarchii, ${caption}',
    ariaAnnounceHierarchyDatum: 'poziom ${level}[number], ${count}[number] dzieci, ${description}',
    ariaAnnounceHoverDatum: '${datum}',
    ariaDescriptionLegendItem: 'Naciśnij Spację lub Enter, aby przełączać widoczność',
    ariaLabelAddHorizontalLine: 'Dodaj linię poziomą',
    ariaLabelAnnotationOptionsToolbar: 'Opcje Adnotacji',
    ariaLabelAnnotationSettingsDialog: 'Ustawienia Adnotacji',
    ariaLabelColorPicker: 'Wybór koloru',
    ariaLabelFinancialCharts: 'Wykresy finansowe',
    ariaLabelLegend: 'Legenda',
    ariaLabelLegendItem: '${label}, Element legendy ${index}[number] z ${count}[number]',
    ariaLabelLegendItemUnknown: 'Nieznany element legendy',
    ariaLabelLegendPageNext: 'Następna strona legendy',
    ariaLabelLegendPagePrevious: 'Poprzednia strona legendy',
    ariaLabelLegendPagination: 'Stronicowanie legendy',
    ariaLabelNavigator: 'Nawigator',
    ariaLabelNavigatorMaximum: 'Maksimum',
    ariaLabelNavigatorMinimum: 'Minimum',
    ariaLabelNavigatorRange: 'Zakres',
    ariaLabelRangesToolbar: 'Zakresy',
    ariaLabelSettingsTabBar: 'Ustawienia',
    ariaLabelZoomToolbar: 'Powiększenie',
    ariaValuePanRange: '${min}[percent0to2dp] do ${max}[percent0to2dp]',
    contextMenuDownload: 'Pobierz',
    contextMenuPanToCursor: 'Przesuń do tutaj',
    contextMenuToggleOtherSeries: 'Przełącz inne serie',
    contextMenuToggleSeriesVisibility: 'Przełącz widoczność',
    contextMenuZoomToCursor: 'Powiększ tutaj',
    dialogHeaderChannel: 'Kanał',
    dialogHeaderDatePriceRange: 'Data i Cena',
    dialogHeaderDateRange: 'Zakres dat',
    dialogHeaderFibonacciRange: 'Fib Odpowiedniość',
    dialogHeaderLine: 'Linia',
    dialogHeaderPriceRange: 'Zakres cenowy',
    dialogHeaderText: 'Tekst',
    dialogInputAlign: 'Wyrównaj',
    dialogInputColorPicker: 'Kolor',
    dialogInputColorPickerAltText: 'Kolor tekstu',
    dialogInputExtendAbove: 'Rozszerz powyżej',
    dialogInputExtendBelow: 'Rozszerz poniżej',
    dialogInputExtendChannelEnd: 'Przedłuż zakończenie kanału',
    dialogInputExtendChannelStart: 'Rozszerz początek kanału',
    dialogInputExtendLeft: 'Rozciągnij w lewo',
    dialogInputExtendLineEnd: 'Przedłuż zakończenie linii',
    dialogInputExtendLineStart: 'Przedłuż początek linii',
    dialogInputExtendRight: 'Rozszerz w prawo',
    dialogInputFibonacciBands: 'Pasma',
    dialogInputFibonacciBandsAltText: 'Pasma Fibonacciego',
    dialogInputFillColorPicker: 'Wypełnij',
    dialogInputFillColorPickerAltText: 'Kolor wypełnienia',
    dialogInputFontSize: 'Rozmiar',
    dialogInputFontSizeAltText: 'Rozmiar czcionki',
    dialogInputLineStyle: 'Kreska',
    dialogInputPosition: 'Pozycja',
    dialogInputReverse: 'Odwróć',
    dialogInputShowFill: 'Pokaż wypełnienie',
    dialogInputStrokeWidth: 'Grubość',
    dialogInputStrokeWidthAltText: 'Grubość linii',
    iconAltTextAlignCenter: 'Wyśrodkuj',
    iconAltTextAlignLeft: 'Lewo',
    iconAltTextAlignRight: 'Prawo',
    iconAltTextClose: 'Zamknij',
    iconAltTextLineStyleDashed: 'Długie kreski',
    iconAltTextLineStyleDotted: 'Krótka kreska',
    iconAltTextLineStyleSolid: 'Solid',
    iconAltTextPositionBottom: 'Dół',
    iconAltTextPositionCenter: 'Środek',
    iconAltTextPositionTop: 'Góra',
    inputTextareaPlaceholder: 'Dodaj Tekst',
    measurerDateRangeBars: '${value}[number] słupków',
    measurerPriceRangePercent: '${value}[percent]',
    measurerPriceRangeValue: '${value}[number]',
    measurerVolume: 'Objętość ${value}',
    overlayLoadingData: 'Ładowanie danych...',
    overlayNoData: 'Brak danych do wyświetlenia',
    overlayNoVisibleSeries: 'Brak widocznych serii',
    overlayUnsupportedBrowser: 'Niekompatybilna wersja przeglądarki. Proszę zaktualizować przeglądarkę.',
    seriesHistogramTooltipCount: '${yName} (liczba)',
    seriesHistogramTooltipFrequency: 'Częstotliwość',
    seriesHistogramTooltipMean: '${yName} (średnia)',
    seriesHistogramTooltipSum: '${yName} (suma)',
    toolbarAnnotationsArrow: 'Strzałka',
    toolbarAnnotationsArrowDown: 'Strzałka w dół',
    toolbarAnnotationsArrowUp: 'Strzałka w górę',
    toolbarAnnotationsCallout: 'Adnotacja',
    toolbarAnnotationsClearAll: 'Wyczyść wszystkie',
    toolbarAnnotationsComment: 'Komentarz',
    toolbarAnnotationsDatePriceRange: 'Data i cena',
    toolbarAnnotationsDateRange: 'Zakres dat',
    toolbarAnnotationsDelete: 'Usuń',
    toolbarAnnotationsDisjointChannel: 'Rozłączony kanał',
    toolbarAnnotationsDragHandle: 'Przeciągnij pasek narzędzi',
    toolbarAnnotationsFibonacciAnnotations: 'Fibonacci',
    toolbarAnnotationsFibonacciRetracement: 'Fib Odbicie',
    toolbarAnnotationsFibonacciRetracementTrendBased: "Fib Trend Based' oparty na trendzi",
    toolbarAnnotationsFillColor: 'Kolor wypełnienia',
    toolbarAnnotationsHorizontalLine: 'Linia pozioma',
    toolbarAnnotationsLineAnnotations: 'Linie Trendu',
    toolbarAnnotationsLineColor: 'Kolor linii',
    toolbarAnnotationsLineStrokeWidth: 'Grubość linii',
    toolbarAnnotationsLineStyle: 'Styl linii',
    toolbarAnnotationsLock: 'Zablokuj',
    toolbarAnnotationsMeasurerAnnotations: 'Mierniki',
    toolbarAnnotationsNote: 'Notatka',
    toolbarAnnotationsParallelChannel: 'Kanał równoległy',
    toolbarAnnotationsPriceRange: 'Zakres cen',
    toolbarAnnotationsQuickDatePriceRange: 'Zmierz',
    toolbarAnnotationsSettings: 'Ustawienia',
    toolbarAnnotationsShapeAnnotations: 'Strzałki',
    toolbarAnnotationsText: 'Tekst',
    toolbarAnnotationsTextAnnotations: 'Adnotacje tekstowe',
    toolbarAnnotationsTextColor: 'Kolor tekstu',
    toolbarAnnotationsTextSize: 'Rozmiar tekstu',
    toolbarAnnotationsTrendLine: 'Linia trendu',
    toolbarAnnotationsUnlock: 'Odblokuj',
    toolbarAnnotationsVerticalLine: 'Linia pionowa',
    toolbarRange1Month: '1M',
    toolbarRange1MonthAria: '1 miesiąc',
    toolbarRange1Year: '1R',
    toolbarRange1YearAria: '1 rok',
    toolbarRange3Months: '3M',
    toolbarRange3MonthsAria: '3 miesiące',
    toolbarRange6Months: '6M',
    toolbarRange6MonthsAria: '6 miesięcy',
    toolbarRangeAll: 'Wszystko',
    toolbarRangeAllAria: 'Wszystko',
    toolbarRangeYearToDate: 'Rok Do Dziś',
    toolbarRangeYearToDateAria: 'Od początku roku',
    toolbarSeriesTypeCandles: 'Świece',
    toolbarSeriesTypeDropdown: 'Typ wykresu',
    toolbarSeriesTypeHighLow: 'Wysoki Niski',
    toolbarSeriesTypeHLC: 'HLC',
    toolbarSeriesTypeHollowCandles: 'Świeczki Puste',
    toolbarSeriesTypeLine: 'Linia',
    toolbarSeriesTypeLineWithMarkers: 'Linia z znacznikami',
    toolbarSeriesTypeOHLC: 'OHLC',
    toolbarSeriesTypeStepLine: 'Linia krokowa',
    toolbarZoomPanEnd: 'Przesuń na koniec',
    toolbarZoomPanLeft: 'Przesuń w lewo',
    toolbarZoomPanRight: 'Przesuń w prawo',
    toolbarZoomPanStart: 'Przesuń na początek',
    toolbarZoomReset: 'Resetuj powiększenie',
    toolbarZoomZoomIn: 'Powiększ',
    toolbarZoomZoomOut: 'Oddal',
    tooltipPaginationStatus: '${index}[number] z ${count}[number]',
};
